import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { makeStyles, styled } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import BGnewDiary from '../assets/icons/illustration-rptstd-create.svg'
import BGnewDiaryResponsive from '../assets/icons/illustration-rptstd-create-responsive.svg'
import BGsearchStudentAdmin from '../assets/icons/illustration-rptstd-details.svg'
import BGsearchStudentAdminResponsive from '../assets/icons/illustration-rptstd-details-responsive.svg'

import cardIconTotal from '../assets/icons/cardIconTotal.svg'
import cardIconDone from '../assets/icons/cardIconDone.svg'
import cardIconPending from '../assets/icons/cardIconPending.svg'
import cardIconModerationProf from '../assets/icons/cardIconModeration.svg'
import cardIconModerationAdmin from '../assets/icons/cardIconModerationAdmin.svg'
import cardIconOccurrences from '../assets/icons/cardIconOccurrences.svg'
import noReportSVG from '../assets/icons/no-reportsV2.svg'

import { getReportsCountRSPA, getReports } from '../store/reports/actions'
import CreateReportForm from '../components/form/CreateReportForm'
import SearchReportsForm from '../components/form/SearchReportsForm'
import { roles } from '../utils/constants'
import Button from '../components/button/Button'
import { CircularProgress } from '@material-ui/core'

const InformationCard = styled('div')(
  ({ theme, bgColor, textColor, disableActive }) => ({
    boxSizing: 'border-box',
    minHeight: 280,
    borderRadius: '16px',
    backgroundColor: bgColor || '#FFFFFF',
    marginBottom: '20px',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 10px 18px -3px rgba(0,0,0,0.2)',
      transform: 'translateY(-5px)'
    },
    ...(!disableActive && {
      '&:active': {
        transform: 'scale(0.97)'
      },
      cursor: 'pointer'
    }),
    '& .container': {
      padding: '50px 30px',
      fontFamily: 'Montserrat, Source Sans Pro',
      '& span': {
        color: textColor || '#4D5E80',
        fontWeight: 600,
        lineHeight: '150%',
        letterSpacing: '0%',
        fontSize: '32px'
      },
      '& h1': {
        color: textColor || '#4D5E80',
        fontWeight: 600,
        marginBottom: 25,
        fontSize: 20
      },
      '& p': {
        color: textColor || '#555',
        fontSize: '16px',
        fontWeight: 760,
        lineHeight: '150%',
        letterSpacing: '0%',
        maxWidth: 200,
        margin: 0,
        [theme.breakpoints.down('sm')]: {
          fontSize: '14px'
        }
      },
      [theme.breakpoints.down('430')]: {
        width: 175
      }
    },
    '& .reports_totalCount': {
      height: 40
    },
    '& .circularProgress': {
      paddingTop: 6
    }
  })
)

const LargeBanner = styled('div')(
  ({ theme, bgColor, colorButton, colorText }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: 16,
    gap: 50,
    height: 190,
    backgroundColor: bgColor,
    marginBottom: 20,
    overflow: 'hidden',
    '& .buttonBannerColor': {
      backgroundColor: `${colorButton} !important`
    },
    '& h1, p': {
      color: colorText
    },
    [theme.breakpoints.down('1200')]: {
      height: 270
    },
    [theme.breakpoints.down('750')]: {
      flexDirection: 'column-reverse',
      height: 'fit-content',
      gap: 0
    }
  })
)

const ContainerCard = styled('div')(({ theme }) => {
  const firstTreeChildren = '& > *:nth-child(-n+3)'
  const restChildren = '& > *:nth-child(n+4)'
  const lastChild = '& > *:last-child'
  return {
    display: 'flex',
    gap: 20,
    overflowX: 'auto',
    overflowY: 'visible',
    marginBottom: 10,
    scrollbarWidth: 'thin',
    scrollbarColor: '#ccc transparent',
    '&::-webkit-scrollbar': {
      height: 8
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: 4,
      minWidth: 40
    },
    [theme.breakpoints.up('1400')]: {
      display: 'grid',
      overflowX: 'visible',
      gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
      columnGap: 20
    },
    [theme.breakpoints.down('1400')]: {
      display: 'grid',
      overflowX: 'visible',
      gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
      columnGap: 20,
      rowGap: 20,
      [firstTreeChildren]: {
        gridColumn: 'span 2'
      },
      [restChildren]: {
        gridColumn: 'span 3'
      }
    },
    [theme.breakpoints.down('800')]: {
      [firstTreeChildren]: {
        gridColumn: 'span 3'
      },
      [lastChild]: {
        gridColumn: 'span 6'
      }
    },
    [theme.breakpoints.down('430')]: {
      display: 'flex',
      overflow: 'auto'
    }
  }
})

const NoReportStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 16,
  backgroundColor: '#ffffff',
  borderRadius: '0px 0px 8px 8px',
  paddingBottom: '100px',
  paddingTop: '50px',
  '& h5': {
    color: '#386093'
  },
  '& p': {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '16px',
    leadingTrim: 'NONE',
    lineHeight: '150%',
    letterSpacing: '0px',
    textAlign: 'center',
    verticalAlign: 'middle'
  },
  [theme.breakpoints.down('sm')]: {
    '& h5': {
      fontSize: 18
    }
  },
  '& img': {
    objectFit: 'contain',
    width: '100%',
    maxWidth: 450
  }
}))

const useStyles = makeStyles(theme => ({
  root: {
    width: '98%',
    padding: '1rem 0',
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 16,
    margin: 16,
    [theme.breakpoints.down('426')]: {
      '& button': {
        '& svg': {
          width: '41px !important',
          height: '41px !important',
          minWidth: '41px !important',
          minHeight: '41px !important'
        },
        '& p': {
          fontSize: '12px'
        }
      }
    }
  },
  paper: {
    borderRadius: 8,
    padding: 32,
    [theme.breakpoints.down('426')]: {
      padding: 10
    }
  },
  button_banners: {
    margin: '10px 0 0 0',
    padding: '6px 40px',
    borderRadius: 8,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('1050')]: {
      width: '100%',
      maxWidth: 260,
      margin: '12px auto 0'
    },
    [theme.breakpoints.down('760')]: {
      padding: '6px 34px'
    }
  },
  banner_section: {
    padding: '24px',
    fontFamily: 'Montserrat, Source Sans Pro',
    '& h1, & p': {
      fontStyle: 'normal',
      lineHeight: 'normal',
      textAlign: 'left',
      margin: 0
    },
    '& h1': {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 15
    },
    '& p': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '150%',
      maxWidth: 450
    },
    [theme.breakpoints.down('1350')]: {
      '& h1': {
        fontSize: 20
      },
      '& p': {
        fontSize: 12
      }
    },
    [theme.breakpoints.down('1200')]: {
      padding: '56px 24px'
    },
    [theme.breakpoints.down('750')]: {
      padding: 24
    }
  },
  banner_img_wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 50%',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('1200')]: {
      flex: '0 0 80%'
    },
    [theme.breakpoints.down('750')]: {
      flex: 'unset',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  banner_img: {
    position: 'absolute',
    width: '85%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '0 16px 16px 0',
    transition: 'transform ease-in-out 0.5s',
    [theme.breakpoints.down('1200')]: {
      width: '100%'
    },
    [theme.breakpoints.down('750')]: {
      maxWidth: 400,
      maxHeight: 185,
      position: 'relative',
      padding: 16,
      objectFit: 'unset'
    }
  }
}))

export const NoReportsDiv = () => (
  <NoReportStyled>
    <img src={noReportSVG} alt='imagem da lista de diários vazia' />
    <Typography variant='h5'>Nenhum diário disponível no momento.</Typography>
    <Typography variant='p'>
      Tente aplicar outros filtros para encontrar o que procura.
    </Typography>
  </NoReportStyled>
)

const handleGenerateReport = async (
  reportTemplateId,
  userId,
  generateReportFunction
) => {
  const data = {
    type: 'reports',
    attributes: {
      report_template_id: reportTemplateId,
      user_id: userId
    }
  }
  generateReportFunction(data)
}

const ReportsPage = ({
  userOccupations,
  getReports,
  getReportsCountRSPA,
  reports,
  schoolId,
  componentAttribute
}) => {
  const history = useHistory()
  const isTeacher = userOccupations?.includes(roles.TEACHER)
  const isSchoolAdmin = userOccupations?.includes(roles.SCHOOL_ADMIN)
  const [statusValue, setStatusValue] = React.useState(null)
  const [reportsCount, setReportsCount] = React.useState({
    items: [],
    isFetching: false
  })
  const classes = useStyles()
  const defaultParams = {
    'page[size]': 10,
    'q[year_lteq]': new Date().getFullYear() + 1,
    'q[year_gteq]': new Date().getFullYear(),
    'q[classroom_school_id_eq]': schoolId
  }

  useEffect(() => {
    const fetchReportsCount = async () => {
      setReportsCount(prev => ({ ...prev, isFetching: true }))
      try {
        const res = await getReportsCountRSPA()
        setReportsCount({ items: res || [], isFetching: false })
      } catch (error) {
        setReportsCount(prev => ({ ...prev, isFetching: false }))
      }
    }
    fetchReportsCount()
  }, [])

  const handleStatusChange = value => {
    setStatusValue(value)
  }

  const handleClickGenerateTemplate = () => {
    history.push('reports/create')
  }

  const cardsConfig = [
    {
      key: 'total',
      title: 'Total Diários',
      description: 'Visite todos os diários criados',
      icon: cardIconTotal,
      textColor: '#4D5E80'
    },
    {
      key: 'done',
      title: 'Concluídos',
      description: 'Veja os diários que já foram concluídos',
      icon: cardIconDone,
      textColor: '#4D5E80',
      statusKey: 2
    },
    {
      key: 'occurrences',
      title: 'Ocorrências',
      description: 'Acompanhe o total de ocorrências',
      icon: cardIconOccurrences,
      bgColor: '#FFE9DD',
      textColor: '#F4A87C',
      show: isSchoolAdmin
    },
    {
      key: 'pending',
      title: 'Pendentes',
      description: 'Acompanhe os diários pendentes',
      icon: cardIconPending,
      bgColor: '#FFE2E6',
      textColor: '#EF7C8F',
      statusKey: 1
    },
    {
      key: 'moderation',
      title: 'Moderação',
      icon: isSchoolAdmin ? cardIconModerationAdmin : cardIconModerationProf,
      description: isSchoolAdmin
        ? 'Diários pendentes de moderação'
        : 'Verifique os diários moderados',
      bgColor: isSchoolAdmin ? '#8B598E' : '#FFE9DD',
      textColor: isSchoolAdmin ? '#FFFFFF' : '#F4A87C',
      show: isSchoolAdmin || isTeacher,
      statusKey: 4
    }
  ]
  const handleClickStudentDetail = () => {
    history.push('report_student/details')
  }
  if (componentAttribute?.isCreate) {
    return <CreateReportForm />
  }
  return (
    <div className={classes.root}>
      {!isTeacher && (
        <LargeBanner
          bgColor='#FFE9DD'
          colorButton='#EF7C8F'
          colorText='#4D5E80'
        >
          <div className={classes.banner_section}>
            <h1>Comece um novo Diário!</h1>
            <p>
              Registre o dia da turma e mantenha os pais informados. Personalize
              e compartilhe facilmente!
            </p>
            <Button
              onclick={handleClickGenerateTemplate}
              className={`${classes.button_banners} buttonBannerColor`}
              variant='contained'
            >
              Gerar Diário
            </Button>
          </div>
          <picture className={classes.banner_img_wrapper}>
            <source media='(max-width: 750px)' srcSet={BGnewDiaryResponsive} />
            <source media='(min-width: 751px)' srcSet={BGnewDiary} />
            <img className={classes.banner_img} src={BGnewDiary} />
          </picture>
        </LargeBanner>
      )}
      {
        <LargeBanner bgColor='#386093' colorButton='#F4A87C' colorText='#fff'>
          <div className={classes.banner_section}>
            <h1>Busca detalhada por aluno</h1>
            <p>
              Encontre todos os registros e detalhes dos diários de turma de um
              aluno específico.
            </p>
            <Button
              onclick={handleClickStudentDetail}
              className={`${classes.button_banners} buttonBannerColor`}
              variant='contained'
            >
              Buscar Aluno
            </Button>
          </div>
          <picture className={classes.banner_img_wrapper}>
            <source
              media='(max-width: 750px)'
              srcSet={BGsearchStudentAdminResponsive}
            />
            <source media='(min-width: 751px)' srcSet={BGsearchStudentAdmin} />
            <img className={classes.banner_img} src={BGsearchStudentAdmin} />
          </picture>
        </LargeBanner>
      }
      <ContainerCard isSchoolAdmin={isSchoolAdmin}>
        {cardsConfig.filter(card => card.show !== false).map(card => (
          <InformationCard
            key={card.key}
            bgColor={card.bgColor}
            textColor={card.textColor}
            isSchoolAdmin={isSchoolAdmin}
            disableActive={card.key === 'occurrences'}
            onClick={
              card.key !== 'occurrences'
                ? () => handleStatusChange(card.statusKey)
                : undefined
            }
          >
            <div className='container'>
              <img src={card.icon} alt='' />
              <h1>{card.title}</h1>
              {card.description && <p>{card.description}</p>}
              <div className='reports_totalCount'>
                {reportsCount.isFetching ? (
                  <div className='circularProgress'>
                    <CircularProgress
                      style={{ color: card.textColor }}
                      size={40}
                    />
                  </div>
                ) : (
                  <span>
                    {reportsCount?.items?.[card.key] === 0
                      ? '0000'
                      : reportsCount?.items?.[card.key]}
                  </span>
                )}
              </div>
            </div>
          </InformationCard>
        ))}
      </ContainerCard>
      <SearchReportsForm
        handleGenerateReport={handleGenerateReport}
        defaultParams={defaultParams}
        reports={reports}
        schoolId={schoolId}
        getReports={getReports}
        statusValue={statusValue}
      />
    </div>
  )
}

const mapStateToProps = ({ auth, reports, school }) => {
  return {
    userOccupations: auth.currentOccupation,
    schoolId: school.currentSchool && school.currentSchool.school_id,
    reports: reports
  }
}

const mapDispatchToProps = dispatch => ({
  getReports: data => dispatch(getReports(data)),
  getReportsCountRSPA: data => dispatch(getReportsCountRSPA.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPage)
